export const MIN_CHANNEL = 2;
export const MAX_CHANNEL = 69;

export function wrapChannel(channel: number): number {
  if (channel > MAX_CHANNEL) return MIN_CHANNEL;
  if (channel < MIN_CHANNEL) return MAX_CHANNEL;
  return channel;
}

export function stepChannel(channel: number, direction: "up" | "down"): number {
  return wrapChannel(channel + (direction === "up" ? 1 : -1));
}

export function directionBetween(current: number, next: number): "up" | "down" {
  return next >= current ? "up" : "down";
}
